import React, { useState } from 'react';
import styled from 'styled-components';
import userImageProfile from '../assets/userImageProfile.svg'
import { useNavigate } from "react-router-dom";

const CardAsesores =
  ({
    asesor,
    setSelectedAsesor,
    selectedAsesor
  }) => {
    const navigate = useNavigate();
    // const [editorContacto, setContacto] = useState(false);

    const sendDetallePath = (asesor) => {
      navigate('/asesores/' + `${asesor.id}`)
    }
    console.log(asesor)
    return (

      <DivRow style={{
        backgroundColor: selectedAsesor?.id === asesor.id ? 'rgb(221, 221, 221)' : '#FFFFFF'
      }}

        onClick={() => sendDetallePath(asesor)}
        key={asesor.index}>
        <img
          src={asesor?.imagen_profile || userImageProfile}
          style={{
            width: '28px',
            height: '28px',
            borderRadius: '100%',
            minWidth: "28px",
            minHeight: "28px",
            objectFit: "cover"
          }}
        />
        <Text
          selectedContact={selectedAsesor}
          contact={asesor}>
          {asesor.name} {asesor.lastname}
        </Text>
      </DivRow>
    );
  };

export default CardAsesores;

const Text = styled.span`
  width: -webkit-fill-available;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: ${(prop) => prop.selectedContact?.id === prop.contact.id ? '#07082c' : '#07082c'} ;
`;

const DivRow = styled.div`
  width: -webkit-fill-available;
  padding: 8px;
  display: flex;
  flex-direction: row;
  gap: 5px;
  height: auto;
  align-content: flex-start;
  justify-content: start;
  align-items: center;
  border-top: 1.5px solid #e1e3ea;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
  cursor: pointer;
  background-color: 'transparent' ;
  transition: all 0.3s ease-in-out;
  &:hover{
      box-shadow: rgba(60, 64, 67, 0.9) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
      opacity: 0.5;
      will-change: transform;
  }
  &:active{
      will-change: transform;
  }
`;

